export default "__VITE_ASSET__DLRRJo_5__"